import React, { useCallback, useRef } from "react";
import Webcam from "react-webcam";

// Define types for props
interface WebcameraProps {
  setcaptureImage: (image: string | null) => void;
  setopencamera: (open: boolean) => void;
  handleWebcam: (image: string | null) => void;
}

const Webcamera: React.FC<WebcameraProps> = ({ setcaptureImage, setopencamera, handleWebcam }) => {
  const webcamRef = useRef<Webcam>(null);

  // Create a capture function using useCallback for memoization
  const capture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setcaptureImage(imageSrc);
      setopencamera(false);
      handleWebcam(imageSrc);
    }
  }, [setcaptureImage, setopencamera, handleWebcam]);

  return (
    <div className="web_cam">
      <div className="cam_container">
        {/* Cast the webcamRef to the appropriate type */}
        <Webcam height={600} width={600} ref={webcamRef} />
        <div className="takebtn" onClick={capture}>
          Take
        </div>
      </div>
    </div>
  );
}

export default Webcamera;
